export default {
  path: '/',
  component: () => import('@/layouts/LayoutContentAppNav.vue'),
  meta: { protected: true },
  children: [
    {
      path: 'payroll/salary-structures',
      name: 'PayrollSalaryStructures',
      component: () => import('@/views/payroll/SalaryStructures.vue'),
    },
    {
      path: 'payroll/salary-structures/:staffId',
      name: 'PayrollSalaryStructureEdit',
      component: () => import('@/views/payroll/SalaryStructureEditor.vue'),
    },
    {
      path: 'payroll/settings',
      name: 'PayrollSettings',
      component: () => import('@/views/payroll/PayrollSettings.vue'),
    },
    {
      path: 'payroll/run',
      name: 'PayrollRun',
      component: () => import('@/views/payroll/PayrollRun.vue'),
    },
    {
      path: 'payroll/payslip/:payslipId',
      name: 'PayrollPayslip',
      component: () => import('@/views/payroll/Payslip.vue'),
    },
    {
      path: 'payroll/register',
      name: 'PayrollRegister',
      component: () => import('@/views/payroll/PayrollRegister.vue'),
    },
  ],
}
